import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule }    from '@angular/forms';
import { ConfirmacaoDialog } from '../util/confirmacao.dialog';

/** AngularMaterial **/
import { MatDialogModule, MatIconModule, MatButtonModule } from '@angular/material';
/**
Lista de Componentes do MaterialDesign (importar somento o q for usar)
MaterialModule, MatAutocompleteModule, MatCheckboxModule, MatInputModule, MatRadioModule, MatSelectModule, MatSliderModule, MatSlideToggleModule, MatMenuModule, MatSidenavModule, MatToolbarModule, MatListModule, MatGridListModule, MatCardModule, MatTabsModule, MatButtonModule, MatButtonToggleModule, MatChipsModule, MatIconModule, MatProgressSpinnerModule, MatDialogModule, MatTooltipModule, MatSnackBarModule
**/

@NgModule({
    declarations: [
      ConfirmacaoDialog
    ],
    exports: [
      ConfirmacaoDialog
    ],
    imports: [
      FormsModule, CommonModule, MatIconModule, MatButtonModule,
      MatDialogModule
    ],
    entryComponents: [ConfirmacaoDialog ]

})
export class ConfirmacaoDialogModule {
}
